import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AdalService } from '../authentication/adal.service';
import { SettingsProvider } from './global/settings-provider.service';

export interface FormResult {
	self: string;
	kind: string;
	contents: any;
}

@Injectable()
export class AssetsFetchService {

	gbUrlGetAssetsHierarchy: string;
	gbUrlGetAssetsAttributes: string;
	gbUrlSearchAssets: string;
	gbUrlAssetPath: string;
	gbUrlImpactButton: string;
	

	constructor(
		private adalSvc: AdalService,
		private settingsProvider: SettingsProvider) {
		this.gbUrlGetAssetsHierarchy = settingsProvider.configuration.azurePortalConfig.apiEndpoint + 'GetAssetsHierarchy/';
		this.gbUrlGetAssetsAttributes = settingsProvider.configuration.azurePortalConfig.apiEndpoint + 'GetAssetsAttributes/';
		this.gbUrlSearchAssets = settingsProvider.configuration.azurePortalConfig.apiEndpoint + 'AssetsSearch/';
		this.gbUrlAssetPath = settingsProvider.configuration.azurePortalConfig.apiEndpoint + 'GetAssetPath/';
		this.gbUrlImpactButton = settingsProvider.configuration.azurePortalConfig.apiEndpoint + 'UpdateImpactProduction/';
		
	}


	getAssetsHierarchy(data: any): Observable<any> {
		let url = `${this.gbUrlGetAssetsHierarchy}`;
		return this.adalSvc.post(url, data);
	}

	getAssetsAttributes(data: any): Observable<any> {
		let url = `${this.gbUrlGetAssetsAttributes}`;
		return this.adalSvc.post(url, data);
	}

	searchAssets(data: any): Observable<any> {
		let url = `${this.gbUrlSearchAssets}`;
		return this.adalSvc.post(url, data);
	}

	getAssetPath(data: any): Observable<any> {
		let url = `${this.gbUrlAssetPath}`;
		return this.adalSvc.post(url, data);
	}

	updateShutdownImpact(data: any): Observable<any> {
		let url = `${this.gbUrlImpactButton}`;
		return this.adalSvc.post(url, data);
	}
	
}